import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'horseWeight',
  standalone: true
})
export class HorseWeightPipe implements PipeTransform {

  transform(weight: string | number): string {
    weight = Number(weight);
    return Math.sign(weight)
      ? `${Math.trunc(Number(weight))}lbs`
      : ''
  }

}
